import isUndefined from 'lodash/isUndefined';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'common/image/Image';

export default class HowToRedeem extends Component {
    static propTypes = {
        className: PropTypes.string,
        facility: PropTypes.object.isRequired,
        rate: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        isMonthly: PropTypes.bool.isRequired,
        isAirport: PropTypes.bool,
        airportSection: PropTypes.oneOf(['arrival', 'departure']),
        // An optional title to set the section to. If none is set, the facility title is used.
        sectionTitle: PropTypes.string,
        imgWidth: PropTypes.number,
        imgHeight: PropTypes.number,
    };
    static defaultProps = {
        imgWidth: 200,
        imgHeight: 141,
    };

    constructor(props) {
        super(props);

        const {imgWidth, imgHeight} = props;

        this._imgURL = `https://res.cloudinary.com/spothero/image/upload/c_fill,dpr_2.0,h_${imgHeight},w_${imgWidth},q_50,f_auto/`;
    }

    _renderInstructions(instructions) {
        const {imgWidth, imgHeight} = this.props;

        return (
            <ol>
                {instructions.map((instruction, i) => {
                    const classes = classNames(
                        {'no-illustration': !instruction.illustration_id},
                        {'no-number': instructions.length < 2}
                    );

                    return (
                        <li className={classes} key={i}>
                            <div className="RedemptionInstruction">
                                <div className="RedemptionInstructionRow">
                                    <div className="RedemptionInstructionIllustration">
                                        {instruction.illustration_id && (
                                            <Image
                                                width={imgWidth}
                                                height={imgHeight}
                                                src={`${this._imgURL}${instruction.illustration_id}`}
                                            />
                                        )}
                                    </div>
                                    <div className="RedemptionInstructionText">
                                        <span
                                            className="RedemptionInstructionText-content"
                                            dangerouslySetInnerHTML={{
                                                __html: instruction.text.replace(
                                                    '\n',
                                                    '<br>'
                                                ),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ol>
        );
    }

    _renderMonthly() {
        const {rate} = this.props;

        if (!rate) {
            return null;
        }

        return (
            <Fragment>
                {rate.redemption_instructions.length > 0 && (
                    <div className="TemporaryInstructions">
                        {this._renderInstructions(rate.redemption_instructions)}
                    </div>
                )}
            </Fragment>
        );
    }

    _renderTransient() {
        const {facility} = this.props;

        if (!isUndefined(facility.redemption_instructions)) {
            return this._renderInstructions(facility.redemption_instructions);
        } else {
            return (
                <span
                    dangerouslySetInnerHTML={{
                        __html: facility.post_purchase_instructions,
                    }}
                />
            );
        }
    }

    _renderAirport() {
        const {
            facility: {
                airport: {redemption_instructions: instructions},
            },
            airportSection,
        } = this.props;

        if (!instructions) {
            return null;
        }

        return this._renderInstructions(instructions[airportSection]);
    }

    render() {
        const {
            className,
            facility,
            isMonthly,
            isAirport,
            sectionTitle,
        } = this.props;
        const classes = classNames(
            'SpotDetails-section',
            'HowToRedeem',
            className
        );
        const title = sectionTitle ? sectionTitle : facility.title;

        return (
            <div className={classes}>
                <h4 className="subtitle">{title}</h4>
                {isAirport
                    ? this._renderAirport()
                    : isMonthly
                    ? this._renderMonthly()
                    : this._renderTransient()}
            </div>
        );
    }
}
